<div class="relative full-height">
  <app-loader [enable]="loading$ | async">
    <div class="full-height relative">
      <div class="display-flex ag-grid-no-rows no-data" *ngIf="!(report$ | async).length">
        <div [innerHTML]="'reports.no_data' | translate"></div>
      </div>
      <div class="display-flex flex-column full-height">
        <div>
          <app-sentence></app-sentence>
        </div>
        <div class="flex-grow">
          <div echarts [options]="chartOption$ | async" class="full-height full-width"></div>
        </div>
      </div>
    </div>
  </app-loader>
</div>
